<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="editForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="楼宇" required prop="buildingCode">
                <el-select v-model="editForm.buildingCode" placeholder="点击选择楼宇"  @change="buildingChange" style="width:100%">
                  <el-option
                      v-for="item in buildingList"
                      :key="item.buildingCode"
                      :label="item.name"
                      :value="item.buildingCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="楼层" required prop="floor">
                <el-select v-model="editForm.floor" placeholder="请选择楼层" style="width:100%">
                  <el-option
                      v-for="item in floorValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="房间号" required prop="number">
                <el-input v-model.number="editForm.number"  placeholder="请输入房间号" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="房间类型" required prop="roomTypeCode">
                <el-select v-model="editForm.roomTypeCode" placeholder="请选择房间类型" style="width:100%">
                  <el-option
                      v-for="item in roomTypeList"
                      :key="item.roomTypeCode"
                      :label="item.name"
                      :value="item.roomTypeCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>

        </el-form>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Edit',
  props: ["arr_ins"],
  data() {
    return {
      loading: false,

      floorValue:[],

      buildingList:[],
      roomTypeList:[],

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',
        roomCode:'',
        floor:'',
        buildingCode:'',
        number:null,
        roomTypeCode:'',
        status:''
      },

      status2: [{
        value: 0,
        label: '正常'
      }, {
        value: 1,
        label: '被禁用'
      }],


      rules:{
        floor:[
          { required: true, message: '请输入楼层', trigger: 'blur' },
        ],
        number:[
          { required: true, message: '请输入房间号', trigger: 'blur' },
        ],
        buildingCode:[
          { required: true, message: '请选择楼宇', trigger: 'blur' },
        ],
        roomTypeCode:[
          { required: true, message: '请选择房间类型', trigger: 'blur' },
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
      }

    }
  },

  methods: {

    init(row){

      this.editForm.number = row.number;
      this.editForm.floor = row.floor;
      this.editForm.buildingCode = row.buildingCode;
      this.editForm.roomCode = row.roomCode;
      this.editForm.roomTypeCode = row.roomTypeCode;
      this.editForm.status = row.status;
      this.editForm.institutionCode = row.institutionCode;

      this.getBuild();
      this.getRoomType();


    },

    closeSelf() {
      this.$emit("closeEdit");
    },

    insChange(val){
      this.editForm.institutionCode = val;

      this.buildingList = [];
      this.editForm.buildingCode = '';
      this.getBuild();

      this.roomTypeList = [];
      this.editForm.roomTypeCode = '';
      this.getRoomType();
    },


    getBuild(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Building/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.editForm.institutionCode,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.buildingList = response.data.data;

          for(var i in this.buildingList){
            if(this.buildingList[i].buildingCode==this.editForm.buildingCode){
              var floor=this.buildingList[i].floor
              this.getfloorValue(floor)
            }
          }

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })

    },
    buildingChange:function(selVal){

      this.editForm.buildingCode = selVal;

      var floor='';
      for(var i in this.buildingList){
        if(this.buildingList[i].buildingCode==selVal){
          floor=this.buildingList[i].floor
        }
      }
      var list=[];
      for(var j=0;j<floor;j++){
        var listValue={}
        listValue.label=j+1;
        listValue.value=j+1;
        list.push(listValue)
      }
      this.floorValue=list;
      this.editForm.floor='';

    },

    getRoomType(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RoomType/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.editForm.institutionCode,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.roomTypeList = response.data.data;
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })

    },



    getfloorValue:function(floor){
      var list=[];
      for(var j=0;j<floor;j++){
        var listValue={}
        listValue.label=j+1;
        listValue.value=j+1;
        list.push(listValue)
      }
      this.floorValue=list;
    },


    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })


    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Room/GovEditIns",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>

</style>
